import { render, staticRenderFns } from "./Jogos.vue?vue&type=template&id=0ff0a54d&"
import script from "./Jogos.vue?vue&type=script&lang=js&"
export * from "./Jogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports